import React from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home/Home/Home";
import Blogs from "./Pages/Blogs/Blogs";
import Login from "./Pages/Login/Login/Login";
import Register from "./Pages/Login/Register/Register";
import NotFound from "./Pages/Shared/NotFound/NotFound";
import Footer from "./Pages/Shared/Footer/Footer";
import AllProjects from "./Pages/AllProjects/AllProjects";
import Contact from "./Pages/Contact/Contact";
import Experience from "./Pages/Experience/Experience";
import ProjectDetail from "./Pages/ProjectDetail/ProjectDetail";
import CustomCursor, {
  useCustomCursor,
} from "./Pages/CustomCursor/CustomCursor";
import Smoke from "./Pages/Smoke/Smoke";

function App() {
  const { cursorVariant, textEnter, textLeave, setCursorVariant } =
    useCustomCursor();

  return (
    <div className="App">
      <Smoke />
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Home
                textEnter={textEnter}
                textLeave={textLeave}
                setCursorVariant={setCursorVariant}
              />
            </div>
          }
        />
        <Route
          path="home"
          element={
            <div>
              <Home
                textEnter={textEnter}
                textLeave={textLeave}
                setCursorVariant={setCursorVariant}
              />
            </div>
          }
        />
        <Route
          path="blogs"
          element={
            <div>
              <Smoke />
              <Blogs textEnter={textEnter} textLeave={textLeave} />
            </div>
          }
        />
        <Route
          path="allProjects"
          element={
            <div>
              <Smoke />
              <AllProjects textEnter={textEnter} textLeave={textLeave} />
            </div>
          }
        />
        <Route
          path="project/:projectId"
          element={
            <ProjectDetail textEnter={textEnter} textLeave={textLeave} />
          }
        />
        <Route
          path="login"
          element={<Login textEnter={textEnter} textLeave={textLeave} />}
        />
        <Route
          path="register"
          element={<Register textEnter={textEnter} textLeave={textLeave} />}
        />
        <Route
          path="experience"
          element={
            <div>
              <Experience textEnter={textEnter} textLeave={textLeave} />
            </div>
          }
        />
        <Route
          path="contact"
          element={<Contact textEnter={textEnter} textLeave={textLeave} />}
        />
        <Route
          path="*"
          element={<NotFound textEnter={textEnter} textLeave={textLeave} />}
        />
      </Routes>
      <Footer textEnter={textEnter} textLeave={textLeave} />
      <ToastContainer />
      <CustomCursor cursorVariant={cursorVariant} />
    </div>
  );
}

export default App;
